import { useState, useCallback, useEffect } from "react";
import { usePoll } from "@/hooks/usePoll";
import { api } from "@/lib/api";

// Polls the unread notification count app-wide and resets when notifications are read.
export function useUnread() {
  const [count, setCount] = useState(0);
  const load = useCallback(async () => {
    try { const r = await api.notificationsUnread(); setCount(r.count || 0); } catch {}
  }, []);
  usePoll(load, 5000, []);
  useEffect(() => {
    const reset = () => setCount(0);
    window.addEventListener("notif-read", reset);
    return () => window.removeEventListener("notif-read", reset);
  }, []);
  return count;
}
